var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SdsInputBase } from '../_sds-input-base';
import styles from './sds-time-picker-input.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-time-picker-input` is a web component input field for selecting and displaying time values.
 * It provides attributes for setting minimum and maximum time values.
 *
 * ### Attributes
 * - `max-value`: The maximum time value allowed.
 * - `min-value`: The minimum time value allowed.
 *
 * @tag sds-time-picker-input
 */
let SdsTimePickerInput = (() => {
    var _SdsTimePickerInput_maxValue_accessor_storage, _SdsTimePickerInput_minValue_accessor_storage, _SdsTimePickerInput__input_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-time-picker-input')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let _maxValue_decorators;
    let _maxValue_initializers = [];
    let _maxValue_extraInitializers = [];
    let _minValue_decorators;
    let _minValue_initializers = [];
    let _minValue_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    var SdsTimePickerInput = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTimePickerInput_maxValue_accessor_storage.set(this, __runInitializers(this, _maxValue_initializers, void 0));
            _SdsTimePickerInput_minValue_accessor_storage.set(this, (__runInitializers(this, _maxValue_extraInitializers), __runInitializers(this, _minValue_initializers, void 0)));
            _SdsTimePickerInput__input_accessor_storage.set(this, (__runInitializers(this, _minValue_extraInitializers), __runInitializers(this, __input_initializers, void 0)));
            this._isNumber = (__runInitializers(this, __input_extraInitializers), /^\d$/);
            this._excludedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
            this.stopPropagationAndPreventDefault = (event) => {
                event.stopPropagation();
                event.preventDefault();
            };
            this.validate = (event) => {
                const key = event.key;
                if (this._excludedKeys.includes(key)) {
                    return;
                }
                if (key === 'ArrowUp') {
                    this.increment();
                    event.preventDefault();
                    return;
                }
                if (key === 'ArrowDown') {
                    this.decrement();
                    event.preventDefault();
                    return;
                }
                if (!this._isNumber.test(key)) {
                    event.preventDefault();
                    return;
                }
                const target = event.target;
                const value = target.value;
                const positionStart = target.selectionStart;
                const positionEnd = target.selectionEnd;
                const newValue = +(value.slice(0, positionStart) + key + value.slice(positionEnd));
                if (isNaN(newValue) || newValue < this.minValue || newValue > this.maxValue) {
                    event.preventDefault();
                    return;
                }
            };
            this.increment = () => {
                let numValue = +this.value + 1;
                if (numValue > this.maxValue) {
                    numValue = this.minValue;
                }
                this.setValue(numValue);
                this.handleChanged();
            };
            this.decrement = () => {
                let numValue = +this.value - 1;
                if (numValue < this.minValue) {
                    numValue = this.maxValue;
                }
                this.setValue(numValue);
                this.handleChanged();
            };
            this.handleScroll = (event) => {
                if (!this.focused) {
                    return;
                }
                const deltaY = event.deltaY;
                if (deltaY > 0) {
                    this.decrement();
                }
                else {
                    this.increment();
                }
                event.preventDefault();
            };
        }
        /**
         * The maximum time value allowed for this input.
         * This attribute sets an upper limit on the time that can be selected.
         *
         * @attr {number} max-value - The maximum allowable time value.
         */
        get maxValue() { return __classPrivateFieldGet(this, _SdsTimePickerInput_maxValue_accessor_storage, "f"); }
        set maxValue(value) { __classPrivateFieldSet(this, _SdsTimePickerInput_maxValue_accessor_storage, value, "f"); }
        /**
         * The minimum time value allowed for this input.
         * This attribute sets a lower limit on the time that can be selected.
         *
         * @attr {number} min-value - The minimum allowable time value.
         */
        get minValue() { return __classPrivateFieldGet(this, _SdsTimePickerInput_minValue_accessor_storage, "f"); }
        set minValue(value) { __classPrivateFieldSet(this, _SdsTimePickerInput_minValue_accessor_storage, value, "f"); }
        get _input() { return __classPrivateFieldGet(this, _SdsTimePickerInput__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsTimePickerInput__input_accessor_storage, value, "f"); }
        handleFocus() {
            this.value = (+this.value).toString();
            super.handleFocus();
        }
        handleBlur() {
            this.value = this.convertVal(+this.value);
            super.handleBlur();
        }
        getInput() {
            return this._input;
        }
        async connectedCallback() {
            var _a, _b, _c, _d;
            super.connectedCallback();
            await this.updateComplete;
            (_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', this.validate);
            (_b = this.getInput()) === null || _b === void 0 ? void 0 : _b.addEventListener('wheel', this.handleScroll);
            (_c = this.getInput()) === null || _c === void 0 ? void 0 : _c.addEventListener('paste', this.stopPropagationAndPreventDefault);
            (_d = this.getInput()) === null || _d === void 0 ? void 0 : _d.addEventListener('drop', this.stopPropagationAndPreventDefault);
        }
        disconnectedCallback() {
            var _a, _b, _c, _d;
            super.disconnectedCallback();
            (_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', this.validate);
            (_b = this.getInput()) === null || _b === void 0 ? void 0 : _b.removeEventListener('wheel', this.handleScroll);
            (_c = this.getInput()) === null || _c === void 0 ? void 0 : _c.removeEventListener('paste', this.stopPropagationAndPreventDefault);
            (_d = this.getInput()) === null || _d === void 0 ? void 0 : _d.removeEventListener('drop', this.stopPropagationAndPreventDefault);
        }
        render() {
            return html `
            <div class="${this.getClasses()}">
                <div class="sds-input__wrapper">
                    ${this.renderInput('text')}
                    <sds-icon
                        class="sds-input__icon"
                        @pointerdown="${this.increment}"
                        size="8"
                        name="arrow_up_small"
                    ></sds-icon>
                    <sds-icon
                        class="sds-input__icon"
                        @pointerdown="${this.decrement}"
                        size="8"
                        name="arrow_down_small"
                    ></sds-icon>
                </div>

                ${this.renderMessages()}
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-input': true,
                'sds-input-time': true,
                'sds-input--focused': this.focused,
                'sds-input--disabled': this.disabled,
                'sds-input--invalid': this.invalid,
                'sds-input--searchable': this.searchable,
                'sds-input--pagination': this.pagination,
            });
        }
        emptyValue() {
            return '';
        }
        convertValue(value) {
            return value;
        }
        setValue(value) {
            if (!this.focused) {
                this.value = this.convertVal(value);
            }
            else {
                this.value = value.toString();
            }
        }
        convertVal(value) {
            return !value ? '00' : (value - 10 < 0 ? '0' : '') + value.toString();
        }
    };
    _SdsTimePickerInput_maxValue_accessor_storage = new WeakMap();
    _SdsTimePickerInput_minValue_accessor_storage = new WeakMap();
    _SdsTimePickerInput__input_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTimePickerInput");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _maxValue_decorators = [property({ type: Number })];
        _minValue_decorators = [property({ type: Number })];
        __input_decorators = [query('input.sds-input__element')];
        __esDecorate(_classThis, null, _maxValue_decorators, { kind: "accessor", name: "maxValue", static: false, private: false, access: { has: obj => "maxValue" in obj, get: obj => obj.maxValue, set: (obj, value) => { obj.maxValue = value; } }, metadata: _metadata }, _maxValue_initializers, _maxValue_extraInitializers);
        __esDecorate(_classThis, null, _minValue_decorators, { kind: "accessor", name: "minValue", static: false, private: false, access: { has: obj => "minValue" in obj, get: obj => obj.minValue, set: (obj, value) => { obj.minValue = value; } }, metadata: _metadata }, _minValue_initializers, _minValue_extraInitializers);
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTimePickerInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTimePickerInput = _classThis;
})();
export { SdsTimePickerInput };
